import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "OCE DOGS";
const ORIGIN = "https://www.ocedogs.com";
const DEFAULT_IMAGE = `${ORIGIN}/og-image.jpg`;
const DEFAULT_DESC =
  "The Oceanic (AU + NZ) home for WARDOGS — live King-of-the-Hill server, forum, clans, leaderboards & season pass.";

// [title, description] per public route. Titles render as "<title> · OCE DOGS".
const MAP = {
  "/": ["Oceanic WARDOGS Community", DEFAULT_DESC],
  "/live": ["Live Server", "Live OCE DOGS WARDOGS server status — players, faction scores, current map and how to join."],
  "/forum": ["Community Forum", "Join the OCE DOGS forum — tactics, clips, LFG and WARDOGS discussion for AU/NZ players."],
  "/leaderboard": ["Leaderboards", "Top OCE DOGS operators — kills, wins, cash and faction rankings."],
  "/bans": ["Ban List", "The OCE DOGS WARDOGS server ban list — players removed for breaking the rules."],
  "/clans": ["Clans", "OCE DOGS clans — browse, join or create a WARDOGS clan in AU/NZ."],
  "/tournaments": ["Tournaments", "OCE DOGS WARDOGS tournaments — brackets, teams and results for AU/NZ."],
  "/ladders": ["Competitive Ladders", "OCE DOGS WARDOGS competitive ladders — seasons, rankings and match results."],
  "/database": ["WARDOGS Database", "WARDOGS weapons, vehicles and gear stats — the OCE DOGS database."],
  "/compare": ["Compare Weapons", "Compare WARDOGS weapon stats side by side on OCE DOGS."],
  "/economy": ["Economy", "The WARDOGS cash economy — earnings, gear costs and market trends."],
  "/loadouts": ["Loadout Builder", "Build, price and share WARDOGS loadouts on OCE DOGS."],
  "/ttk": ["TTK Calculator", "WARDOGS time-to-kill and damage calculator."],
  "/tierlist": ["Tier List", "Community WARDOGS weapon tier list — vote and compare."],
  "/map": ["Tactical Maps", "WARDOGS map layouts and tactical callouts."],
  "/guides": ["Guides", "OCE DOGS operator guides for WARDOGS — tactics, economy and gunplay."],
  "/season": ["Season Pass", "Track the OCE DOGS season pass — tiers, rewards and progress."],
  "/loot": ["Loot Drops", "Latest WARDOGS loot drops on OCE DOGS."],
  "/market": ["Marketplace", "Buy and trade WARDOGS cosmetics on the OCE DOGS marketplace."],
  "/clips": ["Clips", "The best OCE DOGS WARDOGS clips from the community."],
  "/screenshots": ["Screenshots", "OCE DOGS WARDOGS screenshots from AU/NZ operators."],
  "/matches": ["Match Feed", "Live OCE DOGS WARDOGS match results and recaps."],
  "/events": ["Events", "OCE DOGS community events for WARDOGS."],
  "/challenges": ["Challenges", "Weekly OCE DOGS challenges for WARDOGS."],
  "/patch-notes": ["Patch Notes", "OCE DOGS platform patch notes and updates."],
  "/supporter": ["Become a Founder", "Support the OCE DOGS server — become a lifetime Founder and keep it running."],
  "/store": ["Store", "Official OCE DOGS merch store — WARDOGS-inspired apparel and gear, shipped across AU/NZ."],
  "/blog": ["News & Articles", "OCE DOGS news, WARDOGS patch breakdowns, guides and community articles for AU/NZ gamers."],
  "/team": ["Our Team", "Meet the OCE DOGS staff and volunteers who run the Oceanic WARDOGS community."],
  "/community": ["Our Servers", "OCE DOGS community WARDOGS servers across Australia and New Zealand."],
  "/founders-wall": ["Founders Wall", "The OCE DOGS Founders — supporters keeping the Oceanic WARDOGS server online."],
  "/about": ["About & Contact", "About OCE DOGS — the fan-made Oceanic WARDOGS community. Get in touch."],
  "/privacy": ["Privacy Policy", "OCE DOGS privacy policy."],
  "/terms": ["Terms of Service", "OCE DOGS terms of service."],
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};
const removeMeta = (attr, key) => document.head.querySelectorAll(`meta[${attr}="${key}"]`).forEach((el) => el.remove());
const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

// Static-route SEO + per-navigation reset. Data-driven pages call useSeo() to
// override these defaults (and may set JSON-LD / noindex, which we clear here).
const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const known = Object.prototype.hasOwnProperty.call(MAP, pathname);
    // reset per-page overrides left by a previous dynamic page
    document.head.querySelectorAll('script[data-seo-jsonld="page"]').forEach((s) => s.remove());
    removeMeta("name", "robots");
    setCanonical(ORIGIN + pathname);
    setMeta("property", "og:image", DEFAULT_IMAGE);
    setMeta("name", "twitter:image", DEFAULT_IMAGE);
    setMeta("property", "og:type", "website");

    if (!known) return; // dynamic/detail route — its own useSeo() sets title/desc
    const entry = MAP[pathname];
    const desc = entry[1];
    const full = pathname === "/"
      ? `${SITE} — Oceanic WARDOGS Community`
      : `${entry[0]} \u00B7 ${SITE}`;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", desc);
    setMeta("property", "og:url", ORIGIN + pathname);
  }, [pathname]);
  return null;
};

export default RouteSeo;
